import React, { forwardRef } from 'react';
import { 
  Box, 
  Typography, 
  Divider, 
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Container
} from '@mui/material';
import { format } from "date-fns";

const BalanceReceipt = forwardRef(({ order, splitPayments, deliveryFee, deliveryPaymentMethod }, ref) => {

  console.log("Received Order is",order); 
  const formatToMyanmarCurrency = (number) => {
      const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
      return `${formattedNumber}`;
    };

    const printStyles = `
    @media print {
      @page {
        size: 80mm auto;
        margin: 0mm;
      }
      body {
        width: 80mm;
        margin: 0;
        padding: 5mm;
        line-height: 1.2;
      }
      .print-container {
        width: 100%;
        max-width: 576px; /* 80mm at 203 DPI */
        font-size: 12px !important; /* Base font size for print */
        min-height: unset; /* Remove any minimum height constraints */
        height: auto; /* Let height be determined by content */
        break-inside: avoid; /* Prevent page breaks within the container */
      }
      h3 { font-size: 20px !important; margin: 4px 0; }
      h4 { font-size: 14px !important; margin: 4px 0; }
      img { max-width: 60px; height: auto; }
      .MuiTypography-root { font-size: 12px; }
      .MuiTableCell-root { font-size: 12px;padding: 2px 8px !important; }
      .MuiGrid-item { font-size: 12px;padding: 2px !important; }
    }
      /* Ensure no extra space after content */
    .print-container > *:last-child {
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }
    /* Prevent breaking of table and grid content */
    .MuiTable-root, .MuiGrid-container {
      break-inside: avoid;
    }
      `;

  return (
    <Container ref={ref} className="print-container" elevation={0}>
       <style>{printStyles}</style>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="h4">Order #{order.orderID}</Typography>
        <Typography variant="body2">
          {format(new Date(),"dd-MM-yyyy hh:mm a")}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" gutterBottom>အော်ဒါအချက်အလက်</Typography>
        <TableContainer>
          <Table size='small'>
            <TableBody>
            <TableRow>
                <TableCell>‌အော်ဒါမှာသည့်နေ့စွဲ</TableCell>
                <TableCell align="right">
                  {format(new Date(order.orderDate.toDate()),"dd-MM-yyyy")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>စုစုပေါင်းသင့်ငွေ</TableCell>
                <TableCell align="right">
                  {formatToMyanmarCurrency(Number(order.total))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>ယခင်ပေးငွေ</TableCell>
                <TableCell align="right">
                  {formatToMyanmarCurrency(Number(order.paymentAmount))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>ယခင်ကျန်ငွေ</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  {formatToMyanmarCurrency(Number(order.remainingBalance))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" gutterBottom>ယခု‌ပေးငွေ</Typography>
        <TableContainer>
          <Table size='small'>
            <TableBody>
              {splitPayments.map((payment, index) => (
                <TableRow key={index}>
                  <TableCell>{payment.method}</TableCell>
                  <TableCell align="right">{formatToMyanmarCurrency(payment.amount)}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                  <TableCell><strong>စုစုပေါင်း</strong></TableCell>
                  <TableCell align="right">
                    <strong>
                      {formatToMyanmarCurrency(
                        splitPayments.reduce((sum, payment) => sum + payment.amount, 0)
                      )}
                    </strong>
                  </TableCell>
            </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

    </Container>
  );
});

export default BalanceReceipt;